export const PHONE_MIN_DIGITS = 10;

export function getDigitCount(s: string): number {
  return (s || "").replace(/\D/g, "").length;
}

export function validatePhone(
  countryCode: string,
  phone: string
): string | null {
  const ccDigits = getDigitCount(countryCode);
  const phoneDigits = getDigitCount(phone);
  const total = ccDigits + phoneDigits;

  if (total === 0) return null;
  if (total < PHONE_MIN_DIGITS) {
    return `Phone number must have at least ${PHONE_MIN_DIGITS} digits (e.g. country 1 + 10 digits for US)`;
  }
  return null;
}

export function isPhoneValid(countryCode: string, phone: string): boolean {
  return validatePhone(countryCode, phone) === null;
}
